import * as React from "react";
import "./PortalLayout.less";
import {FormattedMessage} from "react-intl";
import {Layout, Menu, Dropdown, Tooltip, ConfigProvider, notification} from "antd";
import MenuSlider from "../components/portal/MenuSlider";
import {observer} from "mobx-react";
import {teamStore} from "../models/TeamStore";
import moment from "moment";
import "moment/locale/zh-cn";
import translation from "../assets/image/translation.svg";
import {RouteComponentProps, withRouter} from "react-router";
import {miniPersistStore} from "../models/MiniPersistStore";
import {push, getCurrentLan} from "@netless/i18n-react-router";
import netless_logo from "../assets/image/netless_black.svg";
import SwitchLanguages from "../components/SwitchLanguages";
import {
    HomeOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    PoweroffOutlined, ReadOutlined, SmileOutlined,
    UserOutlined,
} from "@ant-design/icons/lib";
import zh_CN from "antd/lib/locale/zh_CN";
import en from "antd/lib/locale/en_US";
import { Locale } from "antd/lib/locale-provider";

const {Sider, Header, Footer} = Layout;

export type PortalLayoutState = {
    collapsed: boolean;
    locale: Locale
};

let alreadyOpenNotification = false;

@observer
class PortalLayout extends React.Component<RouteComponentProps, PortalLayoutState> {
    public constructor(props: RouteComponentProps) {
        super(props);
        this.state = {
            collapsed: false,
            locale: zh_CN,
        };
        notification.config({
            placement: "bottomRight",
        });
    }

    public toggle = (): void => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }

    private openNotification1 = (): void => {
        notification.open({
            message: "通知内容",
            duration: 0,
            description:
                <div>
                    因为业务发展需要，netless 白板已于 2021 年 3 月 31 日后合并到 Agora 公司业务体系内。届时请使用您现有的 netless 账号登陆 agora.io，以完成账号迁移保障既有业务不受影响
                </div>,
            icon: <SmileOutlined style={{ color: "#108ee9" }} />,
        });
    }

    private openNotificationEn1 = (): void => {
        notification.open({
            message: "Notification content",
            duration: 0,
            description:
                <div>
                    Due to business development needs, netless whiteboard has been merged into Agora's business system after March 31, 2021. At that time, please use your existing netless account to log in to agora.io to complete the account migration to ensure that the existing business will not be affected
                </div>,
            icon: <SmileOutlined style={{ color: "#108ee9" }} />,
        });
    }

    private openNotification2 = (): void => {
        notification.open({
            message: "迁移通知",
            duration: 0,
            description:
                <div>
                    如果您已有agora声网账号（非第三方登录）且账号与netless账号邮箱一致，您只需登录声网账号完成同意操作后，您的白板账号将与声网账号合并<br/>
                    如果您没有agora声网账号，声网将为您用netless账号创建一个账号，需要您在声网官网重置密码后即可继续使用netless白板后台功能（详情可参考https://docs.agora.io/cn/whiteboard/enable_whiteboard）<br/>
                    请在3月31日后及时登陆声网后台完成账号的迁移，以避免您的业务收到影响<br/>
                    目前netless后台可以继续查看您的白板用量，账单信息将通过声网推送，4月账单出具后未完成账号迁移操作的用户有可能被冻结用量<br/>
                </div>,
            icon: <SmileOutlined style={{ color: "#108ee9" }} />,
        });
    }

    private openNotificationEn2 = (): void => {
        notification.open({
            message: "Migration notice",
            duration: 0,
            description:
                <div>
                    If you already have an Agora account (not a third-party login) and the account is the same as the netless account mailbox, you only need to log in to the Agora account to complete the consent operation, and your whiteboard account will be merged with the Agora account<br/>
                    If you don't have an Agora account, the Agora will create an account for you with a netless account. You need to reset your password on the official website of the Agora website to continue to use the netless whiteboard background function (for details, please refer to https://docs.agora. io/cn/whiteboard/enable_whiteboard)<br/>
                    Please log in to the Agora backstage to complete the account migration after March 31 to avoid impact on your business<br/>
                    At present, the netless background can continue to view your whiteboard usage, and the billing information will be pushed through the Agora. Users who have not completed the account migration operation after the bill is issued in April may be frozen.
                </div>,
            icon: <SmileOutlined style={{ color: "#108ee9" }} />,
        });
    }

    public async componentDidMount(): Promise<void> {
        const isEnglish: boolean = getCurrentLan() === "en";
        notification.destroy();
        if (isEnglish) {
            moment.locale("en");
            this.setState({ locale: en });
            if (!alreadyOpenNotification) {
                this.openNotificationEn1();
                this.openNotificationEn2();
                alreadyOpenNotification = true;
            }
        } else {
            moment.locale("zh-cn");
            this.setState({ locale: zh_CN });
            if (!alreadyOpenNotification) {
                this.openNotification1();
                this.openNotification2();
                alreadyOpenNotification = true;
            }
        }
        if (miniPersistStore.token) {
            await teamStore.loadMyTeam(this.props.history);
        }
    }

    public render(): React.ReactNode {

        const user_menu = (
            <Menu style={{width: 120}}>
                <Menu.Item
                    onClick={() => {
                        push(this.props.history, "/user-center/info/");
                    }}
                >
                    <UserOutlined/>
                    <span>
                        <FormattedMessage
                            id={"global.user-center"}
                        />
                    </span>
                </Menu.Item>
                <Menu.Divider/>
                <Menu.Item onClick={() => {
                    miniPersistStore.logout(this.props.history);
                }}>
                    <PoweroffOutlined/>
                    <span>
                        <FormattedMessage
                            id={"layout.sign-out"}
                        />
                    </span>
                </Menu.Item>
            </Menu>
        );


        return (
            <ConfigProvider locale={this.state.locale}>
                <Layout style={{height: "100%"}}>
                    <Sider
                        className="side-box"
                        style={{backgroundColor: "white"}}
                        trigger={null}
                        collapsible
                        collapsed={this.state.collapsed}
                    >
                        <div className="menu-logo">
                            <img onClick={() => push(this.props.history, "/")}
                                style={{width: this.state.collapsed ? 54 : 80, cursor: "pointer"}}
                                src={netless_logo} alt={"netless_logo"}/>
                        </div>
                        <MenuSlider/>
                    </Sider>
                    <Layout className="console-layout">
                        <Header style={{backgroundColor: "white", padding: 0, borderBottom: "1px solid #E0E0E0"}}
                                className="console-nav">
                            <div onClick={this.toggle}
                                className="icon-box">
                                {this.state.collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                            </div>
                            <div className="console-nav-right">
                                <Tooltip placement="bottom" title={<FormattedMessage id={"layout.landing-page"}/>}>
                                    <a target="_blank" href="http://netless.link/">
                                        <div className="console-nav-cell">
                                            <HomeOutlined style={{color: "#000000"}} />
                                        </div>
                                    </a>
                                </Tooltip>
                                <Tooltip placement="bottom" title={<FormattedMessage id={"layout.dev-docs"}/>}>
                                    <a target="_blank" href="https://developer.herewhite.com/#/">
                                        <div className="console-nav-cell">
                                            <ReadOutlined style={{color: "#000000"}}/>
                                        </div>
                                    </a>
                                </Tooltip>
                                <Dropdown placement="bottomRight" overlay={user_menu}>
                                    <div className="console-nav-user">
                                        <span>{teamStore.admin && teamStore.admin.email}</span>
                                    </div>
                                </Dropdown>
                                <div className="console-lang">
                                    <img src={translation} alt={"translation"}/>
                                    <SwitchLanguages/>
                                </div>
                            </div>
                        </Header>
                        <div className="portal-body">
                            {this.props.children}
                        </div>
                        <Footer style={{textAlign: "center"}}>
                            <FormattedMessage
                                id={"layout.under-message"}
                            />
                        </Footer>
                    </Layout>
                </Layout>
            </ConfigProvider>
        );
    }
}

export default withRouter(PortalLayout);



// WEBPACK FOOTER //
// ./src/pages/PortalLayout.tsx